import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../../core/api/errorTypes"
import { resendEmailApi } from "../emailApi"

export const useResendEmail = () => {
    const { mutate } = useApiMutation(resendEmailApi, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess() {
        },
    })

    return { mutate }
}
